module.exports = __webpack_public_path__ + "754e111f65179f5ce73ba626777e99de.svg";